import { doc } from 'firebase/firestore';
import { ExternalConnection } from 'shared/types/external-connections';

import {
  CollectionOptions,
  getCollection,
  updateDocWithTimestamp,
} from './helpers';

const flattenObject = (
  obj: Record<string, any>,
  prefix = '',
): Record<string, any> => {
  const result: Record<string, any> = {};

  for (const key in obj) {
    const newKey = prefix ? `${prefix}.${key}` : key;

    if (
      typeof obj[key] === 'object' &&
      obj[key] !== null &&
      !Array.isArray(obj[key])
    ) {
      Object.assign(result, flattenObject(obj[key], newKey));
    } else {
      result[newKey] = obj[key];
    }
  }

  return result;
};

export const updateExternalConnection = async (
  externalConnection: Pick<ExternalConnection, 'id'> &
    Partial<ExternalConnection>,
) => {
  if (!externalConnection.id) {
    return;
  }
  const externalConnectionCollection = getCollection(
    CollectionOptions.ExternalConnections,
  );
  const docRef = doc(externalConnectionCollection, externalConnection.id);
  const flattenedExternalConnection = flattenObject(externalConnection);

  updateDocWithTimestamp(docRef, flattenedExternalConnection);
};
